import Vue from 'vue';

import SubscriptionAPI from '@/api/subscription';

import moment from 'moment';

const state = {
  inside: null,
  preorder: null,
  delivery: null,
  reserve: null,
  inside_lite: null,
  pro: null,
  hotels: null,
  preview: null,
};

const mutations = {
  setAllSubscriptions(state, payload) {
    state.inside = payload.inside;
    state.preorder = payload.preorder;
    state.delivery = payload.delivery;
    state.reserve = payload.reserve;
    // state.inside_lite = payload.inside_lite;
    state.pro = payload.pro;
    state.hotels = payload.hotels;
    state.preview = payload.preview;
  },
  setSingleSubscription(state, payload) {
    state[payload.mode] = payload.subscription;
  },
};

const actions = {
  fetchAll(context, payload) {
    return new Promise((resolve, reject) => {
      SubscriptionAPI.getAll(payload)
        .then((data) => {
          context.commit('setAllSubscriptions', data);

          resolve();

          const paying_amount = Object.values(data).reduce(
            (acc, sub) => (sub.liqpay_id ? acc + sub.price : acc),
            0
          );

          window.Intercom('update', {
            'Paid subscription': paying_amount,
          });
        })
        .catch((error) => {
          context.dispatch('showError', 'subscription_error', { root: true });
          reject(error);
        });
    });
  },
};

const getters = {
  all(state) {
    return {
      inside: state.inside,
      preorder: state.preorder,
      delivery: state.delivery,
      reserve: state.reserve,
      // inside_lite: state.inside_lite,
      pro: state.pro,
      hotels: state.hotels,
      preview: state.preview,
    };
  },
  atleastOneSubscription(state) {
    if (!state.preorder || !state.delivery) return false;
    return (
      !!state.preorder.paid_until ||
      !!state.delivery.paid_until ||
      !!state.reserve.paid_until
    );
  },
  isSubscriptionActive(state) {
    return (mode) => {
      if (!state[mode]) return false;
      return (
        state[mode] &&
        state[mode].paid_until &&
        (moment(state[mode].paid_until).isAfter(moment()) ||
          state[mode].liqpay_id)
      );
    };
  },
  isProUser(state, getters, rootState) {
    if (rootState.cafe && [104, 278].includes(rootState.cafe._id)) return true;
    if (!state.pro) return false;
    return !!state.pro.liqpay_id;
  },
  hasSubscriptionRegularPayment(state) {
    return (mode) => {
      return !!state[mode].liqpay_id;
    };
  },
  isDemoPeriod(state) {
    return (mode) => {
      if (!state.preorder || !state.delivery || !state.inside) return false;

      const preorder_sub = state.preorder;
      const delivery_sub = state.delivery;
      const inside_sub = state.inside;

      const check_fn = (sub) =>
        sub.trial_period_until &&
        moment(sub.trial_period_until).isSameOrBefore(sub.paid_until) &&
        moment(sub.trial_period_until).isAfter(moment());

      if (mode) {
        return check_fn(state[mode]);
      } else {
        return (
          check_fn(preorder_sub) ||
          check_fn(delivery_sub) ||
          check_fn(inside_sub)
        );
      }
    };
  },
  getModeDisplayTitle() {
    return (mode) => {
      return (
        {
          inside: 'INSIDE',
          preorder: 'TAKEAWAY',
          takeaway: 'TAKEAWAY',
          delivery: 'DELIVERY',
          pro: 'PRO',
          reserve: 'RESERVE',
          hotels: 'ROOMS',
          rooms: 'ROOMS',
          preview: 'PREVIEW',
        }[mode] || mode.toUpperCase()
      );
    };
  },
};

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
